import { Component, Input } from '@angular/core';

import { Global } from '../../../../app.global';
import { Constants } from '../../helper/constants';
import { DepartmentReportsTextCopy } from '../../helper/textcopy/department-reports.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'reports-table',
  templateUrl: './reports-table.component.html',
  styleUrls: ['./reports-table.component.scss'],
})
export class ReportsTableComponent {
  @Input() teamsReport: any;
  @Input() totalTeamsReport: any;
  @Input() dateRangeText: any;

  constants = Constants;
  reportsCopy = DepartmentReportsTextCopy;
  selectedFilter = 'month';
  fromDate: Date = null;
  toDate: Date = null;
  currentDate = new Date();
  showCustomReportsDateRange = false;

  constructor(public global: Global) {}

  // ngOnInit() {
  //   this.setTotalValues();
  // }

  setTotalValues() {
    this.teamsReport.forEach((teamReport) => {
      this.totalTeamsReport.queriesAnswered += teamReport.queriesAnswered;
      this.totalTeamsReport.previousQueriesAnswered += teamReport.previousQueriesAnswered;
    });

    this.setPercentCalculations();
  }

  setPercentCalculations() {
    this.totalTeamsReport.percentageChange =
      this.totalTeamsReport.previousQueriesAnswered === 0
        ? 0
        : (this.totalTeamsReport.queriesAnswered - this.totalTeamsReport.previousQueriesAnswered) /
          this.totalTeamsReport.previousQueriesAnswered;
  }
}
